import { useGenericSparkChartIndex } from 'app/agriculture/charts/GenericSparkChart/useGenericSparkChartIndex';

function isValidNumber(value: number | undefined): value is number {
    return typeof value === 'number' && Number.isFinite(value);
}

export function useGenericSparkChartValue(data: Record<string, number>): number | null {
    const index = useGenericSparkChartIndex();
    const value = data[index];
    if (isValidNumber(value)) return value;
    return null;
}
